import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import VuePlotly from 'vue-plotly'
import './plugins/plot'

Vue.component('vue-plotly', VuePlotly)

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  router,
  el: '#app',
  render: h => h(App)
}).$mount('#app')
